<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" showExport="true" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'Transports',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Транспорт',
        canEdit: true,
        apiRoute: 'nsitransport',
        cardName: 'TransportCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
